import { selectConditionCommentaryTableDisplay } from '../../../redux/features/selectors/commentarySelectors/selectConditionCommentary.ts';
import { useAppSelector } from '../../../redux/hooks.ts';
import { CommentarySubSection } from '../components/CommentarySubsection.tsx';
import { CommentaryTable } from '../components/CommentaryTable.tsx';
import { COMMENTARY_TEXT } from '../consts.ts';

const props = COMMENTARY_TEXT['dep-cost'].subItems['condition'];

export const Condition = () => {
  const data = useAppSelector((state) => selectConditionCommentaryTableDisplay(state));

  return (
    <CommentarySubSection {...props}>
      <CommentaryTable {...data} />
    </CommentarySubSection>
  );
};
